// From mutative (MIT)

export function unescapePath(
  path: string | (string | number)[]
): (string | number)[] {
  if (Array.isArray(path)) return path;
  if (path.length === 0) return [];
  const startsWithSlash = path[0] === "/";
  return path
    .split("/")
    .map((_item) => _item.replace(/~1/g, "/").replace(/~0/g, "~"))
    .slice(startsWithSlash ? 1 : 0);
}
